<template>
    <FullFillBox
        :pageID="1002"
        @permissionData="(data) => {
            this.permissionDetails = data
        }"
    >
        <h4>{{ $t('inventory_stock_in') }}</h4>
        <hr>
        <form @submit.prevent="dataToTable">
            <TopDataKeyBox
                :key-label="this.$t('inventory_stock_in')"
                :key-remarks-label="this.$t('inventory_stock_in_remarks')"
                :mode="'stock_in'"
                @returnData=" (returnData)=>{
                    this.getPO = returnData['key']
                    this.getPORemarks = returnData['keyRemarks']
                } "
            />
            <hr>

            <FilterMainContentBox
                ref="filterMainContentBox">
                <FilterDetailContentBox
                    ref="filterDetailContentBox"
                    :mode="''"
                    :update-mode="this.updateMode"
                    @cancelUpdateMode="cancelUpdateMode"
                    @returnProductData="(getProduct) => {
                        if(getProduct.status === 0){
                            this.ctnQty = null
                        }else{
                            this.getComponentProduct = getProduct['details']
                            this.ctnQty = getProduct['details']['out_pack']
                            try{
                                if(this.getComponentLocation.id){
                                    this.canInputNumber = true
                                }
                            }catch(e){}
                        }
                    }"
                >
                    <slot>
                        <LocationSearchBox
                            ref="locationSearchBox"
                            @loc="(value) => {
                                this.canInputNumber = true
                                this.getComponentLocation = value
                                this.$refs.qtyProcessor.getFocus()
                            }"
                        />
                        <div class="row g-0">
                            <QtyProcessor
                                ref="qtyProcessor"
                                :flag="this.canInputNumber"
                                :ctn-qty="this.ctnQty"
                                @returnQty="(returnData)=>{
                                    this.getQty = returnData['qty']
                                    this.getCtn = returnData['ctn']
                                }"
                            />

                            <div class="col-12">
                                <div class="row" style="margin-top: 2px">
                                    <div class="col-lg-1 col-form-label" style="text-align: left">
                                        {{ $t('inventory_stock_in_origin') }}
                                    </div>
                                    <div class="col-lg-5">
                                        <Multiselect
                                            v-model="getOrigin"
                                            :options="originList"
                                            mode="single"
                                            :can-clear=true
                                            :searchable="true"
                                            :create-option="true"
                                            :placeholder="this.$t('inventory_stock_in_search_origin') + ' (' + this.originList.length + ')'"
                                        />
                                    </div>
                                    <div class="col-lg-2 col-form-label" style="text-align: left">
                                        {{ $t('inventory_stock_in_cost') }}
                                    </div>
                                    <div class="col-lg-4">
                                        <input type="number" class="form-control" v-model="getCost">
                                    </div>
                                </div>
                                <div class="row" style="margin-top: 2px">
                                    <div class="col-lg-2 col-form-label" style="text-align: left">
                                        {{ $t('inventory_stock_in_lotNum') }}
                                    </div>
                                    <div class="col-lg-10"><input class="form-control" v-model="getLot"></div>
                                </div>
                                <div class="row" style="margin-top: 2px">
                                    <div class="col-lg-2 col-form-label" style="text-align: left;">
                                        {{ $t('inventory_stock_in_remarks') }}
                                    </div>
                                    <div class="col-lg-10"><input class="form-control" v-model="getRemarks"></div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="row" style="margin-top: 2px">
                                    <div class="col-md-6">
                                        <div class="row">
                                            <div class="col-md-6 col-form-label">{{ $t('table_receive') }}</div>
                                            <div class="col-md-6">
                                                <input class="form-control" type="date" style="width: 100%"
                                                       v-model="receiveDate">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="row">
                                            <div class="col-md-6 col-form-label">{{ $t('table_expiry') }}</div>
                                            <div class="col-md-6">
                                                <input class="form-control" type="date" style="width: 100%"
                                                       v-model="expiryDate">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </slot>
                </FilterDetailContentBox>
            </FilterMainContentBox>
        </form>
        <hr>
        <div ref="tabulatorTableUse"></div>
        <button class="btn btn-primary"
                @click="uploadToServer"
                style="width: 200px;margin: auto auto 5px auto">
            {{ $t('common_upload') }}
        </button>
    </FullFillBox>
</template>

<script>
import FullFillBox from "@/components/routerViewLocation/FullFillBox";
import ProductSearchBox from "@/components/ProductSearchBox";
import LocationSearchBox from "@/components/LocationSearchBox";
import Multiselect from "@vueform/multiselect";
import {TabulatorFull as Tabulator} from "tabulator-tables";
import TopDataKeyBox from "@/components/StockProcessComponents/TopDataKeyBox";
import FilterMainContentBox from "@/components/StockProcessComponents/FilterMainContentBox";
import FilterDetailContentBox from "@/components/StockProcessComponents/FilterDetailContentBox";
import QtyProcessor from "@/components/StockProcessComponents/QtyProcessor";

export default {
    name: "InventoryStockInView",
    components: {
        TopDataKeyBox,
        FilterMainContentBox,
        FilterDetailContentBox,
        QtyProcessor,
        FullFillBox,
        ProductSearchBox,
        LocationSearchBox,
        Multiselect,
    },
    data(){
        return{
            permissionDetails: {},
            updateMode: false,
            updateItemID: '',

            tablePKID: 1,
            tableData: [],

            reloadComponent: true,
            getComponentProduct: null,
            getComponentLocation: null,
            expiryDate: '',
            receiveDate: '',
            nowDataTime: '',
            getRemarks: '',
            getLot: '',
            getCtn: '',
            getQty: '',
            getCost: '',
            getPORemarks: '',
            getPO: '',
            getOrigin: '',
            originList: [],
            ctnQty: null,
            canInputNumber: false,
        }
    },
    methods:{
        cancelUpdateMode(res){
            this.updateMode = false
            this.$refs.qtyProcessor.clearMode()
            this.clearInputData()
        },
        async uploadToServer(){
            if(this.tabulator.getData().length === 0 || this.getPO.length === 0){
                this.$swal.fire({
                    title: this.$t('inventory_stock_in_error_data_required'),
                })
            }else{
                // upload to server
                let returnData = {
                    "po": {
                        "po": this.getPO,
                        "poRemarks": this.getPORemarks,
                    },
                    "data": this.tabulator.getData()
                }
                await this.$mainApi.post('api/inventory/stock-in/', returnData)
                    .then(response => {
                        if(response.data.status === 80){
                            if(response.data.errors.errors_row.length === 0){
                                // No errors
                                this.$toast.success(this.$t('common_success'))
                                this.$router.push('/inventory')
                                // location.href = this.$store.state.frontendServerIp + '/inventory'
                            }else{
                                this.$toast.error(this.$t('error_warning'))
                                this.tabulator.setData(response.data.details.data.data)
                                this.tabulator.setData(this.tabulator.getData().filter(a => response.data.errors.errors_row.includes(a.id)))
                            }
                        }
                    })
            }
        },
        dataToTable(){
            try{
                let data = this.tabulator.getData()
                // Check if duplicate
                if(this.getComponentProduct['id'] && this.getComponentLocation['id'] && this.getQty && this.getCtn){
                    // Check if given data is duplicate
                    let duplicateData = 0
                    if(this.updateMode === false){
                        duplicateData = data.findIndex(a=>
                            a.pid === this.getComponentProduct['id'] &&
                            a.lid === this.getComponentLocation['id'] &&
                            a.lot === this.getLot &&
                            a.cost === this.getCost &&
                            a.origin === this.getOrigin &&
                            a.receiveDate === this.receiveDate &&
                            a.expiryDate === this.expiryDate &&
                            a.remarks === this.getRemarks)
                    }else if(this.updateMode === true){
                        duplicateData = data.findIndex(a=>
                            a.pid === this.getComponentProduct['id'] &&
                            a.lid === this.getComponentLocation['id'] &&
                            a.lot === this.getLot &&
                            a.cost === this.getCost &&
                            a.origin === this.getOrigin &&
                            a.receiveDate === this.receiveDate &&
                            a.expiryDate === this.expiryDate &&
                            a.remarks === this.getRemarks &&
                            a.id !== this.updateItemID)
                    }

                    if(duplicateData === -1){
                        // No Same Data, add NEW
                        data.push({
                            "id": this.tablePKID,
                            "pid": this.getComponentProduct['id'],
                            "lid": this.getComponentLocation['id'],
                            "outCode": this.getComponentProduct['outCode'],
                            "innerCode": this.getComponentProduct['innerCode'],
                            "product_name": this.getComponentProduct['name_en'],
                            "location_name": this.getComponentLocation['label'],
                            "origin": this.getOrigin,
                            "qty": this.getQty,
                            "ctn": this.getCtn,
                            "lot": this.getLot,
                            "cost": this.getCost,
                            "remarks": this.getRemarks,
                            "receiveDate": this.receiveDate,
                            "expiryDate": this.expiryDate,
                        })

                        // if update mode, add new then delete old myself
                        if(this.updateMode === true){
                            data = data.filter(a => a.id !== this.updateItemID)
                        }
                    }else if(duplicateData > -1){
                        // Has Same Data, update OLD
                        if(this.updateMode === true){
                            // update old data to new
                            let newData = {
                                "id": data[duplicateData]['id'],
                                "pid": this.getComponentProduct['id'],
                                "lid": this.getComponentLocation['id'],
                                "outCode": this.getComponentProduct['outCode'],
                                "innerCode": this.getComponentProduct['innerCode'],
                                "product_name": this.getComponentProduct['name_en'],
                                "location_name": this.getComponentLocation['label'],
                                "origin": this.getOrigin,
                                "qty": this.getQty + data[duplicateData]['qty'],
                                "ctn": Math.round((this.getQty + data[duplicateData]['qty']) / this.ctnQty * 10000) / 10000,
                                "lot": this.getLot,
                                "cost": this.getCost,
                                "remarks": this.getRemarks,
                                "receiveDate": this.receiveDate,
                                "expiryDate": this.expiryDate,
                            }
                            data[duplicateData] = {
                                ...data[duplicateData],
                                ...newData
                            }

                            // if update mode, add new then delete old myself
                            data = data.filter(a => a.id !== this.updateItemID)

                        }else if(this.updateMode === false){
                            // old data add new data (But no need delete myself, cuz no myself)
                            // let gotTheItem = false
                            data[duplicateData] = {
                                "id": data[duplicateData]['id'],
                                "pid": this.getComponentProduct['id'],
                                "lid": this.getComponentLocation['id'],
                                "outCode": this.getComponentProduct['outCode'],
                                "innerCode": this.getComponentProduct['innerCode'],
                                "product_name": this.getComponentProduct['name_en'],
                                "location_name": this.getComponentLocation['label'],
                                "origin": this.getOrigin,
                                "qty": this.getQty + data[duplicateData]['qty'],
                                "ctn": Math.round((this.getQty + data[duplicateData]['qty']) / this.ctnQty * 10000) / 10000,
                                "lot": this.getLot,
                                "cost": this.getCost,
                                "remarks": this.getRemarks,
                                "receiveDate": this.receiveDate,
                                "expiryDate": this.expiryDate,
                            }
                        }
                    }
                    this.tablePKID += 1
                    this.tabulator.setData(data)
                    this.clearInputData()
                    this.updateMode = false
                }else{
                    this.$swal.fire({
                        title: this.$t('error_input_stock_in_field_required'),
                        icon: "warning"
                    })
                }
            }catch(e){
                console.log(e)
                this.$swal.fire({
                    title: this.$t('error_input_stock_in_field_required'),
                    icon: "warning"
                })
            }
        },
        clearInputData(){
            this.getQty = ""
            this.getCtn = ""
            this.getLot = ""
            this.getCost = ""
            this.getRemarks = ""
            this.getOrigin = ""
            this.$refs.qtyProcessor.clearMode()
            this.canInputNumber = false
            this.$refs.filterDetailContentBox.resetProductSearch()
        },
        setTimer(){
            let now = new Date();
            const offset = now.getTimezoneOffset()
            now = new Date(now.getTime() - (offset*60*1000))
            this.receiveDate = now.toISOString().substring(0,10);

            let nextYear = new Date();
            const offset2 = nextYear.getTimezoneOffset()
            let nextYear2 = nextYear.setFullYear(nextYear.getFullYear() + 1)
            nextYear2 = new Date(nextYear.getTime() - (offset2*60*1000))
            this.expiryDate = nextYear.toISOString().substring(0,10);
        },
        async getOriginList(){
            await this.$mainApi.get('api/other-details/origin/')
                .then(response => {
                    if(response.data.status === 80){
                        for(let i=0;i<response.data.details.length;i++){
                            this.originList.push({
                                "label": response.data.details[i]['origin'],
                                "value": response.data.details[i]['origin']
                            })
                        }
                    }
                })
        },
    },
    mounted() {
        document.title = this.$t('title') + ' | ' + this.$t('inventory_stock_in')

        this.setTimer()
        this.getOriginList()

        this.tabulator = new Tabulator(this.$refs.tabulatorTableUse, {
            placeholder: "<h3>" + this.$t('common_no_data') + "</h3>",
            data: [],
            columns: [
                {title: "id", field: 'id', resizable: false, sorter: 'number', width: 10, responsive: 0,},
                {title: "pid", field: 'pid', visible: false},
                {title: "lid", field: 'lid', visible: false},
                {title: "receiveDate", field: 'receiveDate', visible: false},
                {title: "expiryDate", field: 'expiryDate', visible: false},
                {
                    title: this.$t('product_outCode_short'), field: 'outCode', sorter: 'string', resizable: false,
                    responsive: 0, minWidth: 150,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('product_innerCode'), field: 'innerCode', sorter: 'string', resizable: false,
                    responsive: 0, minWidth: 150,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('product_product_en'), field: 'product_name', sorter: 'string', resizable: true,
                    responsive: 1, minWidth: 250,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_location'), field: 'location_name', sorter: 'string', resizable: true,
                    responsive: 1, maxWidth: 100,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_qty'), field: 'qty', sorter: 'string', resizable: true,
                    responsive: 1, maxWidth: 80,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_ctn'), field: 'ctn', sorter: 'string', resizable: true,
                    responsive: 1, maxWidth: 80,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_lot_no'), field: 'lot', sorter: 'string', resizable: true,
                    responsive: 2, widthGrow: 1,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_cost'), field: 'cost', sorter: 'string', resizable: true,
                    responsive: 1, maxWidth: 80,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_origin'), field: 'origin', sorter: 'string', resizable: true,
                    responsive: 1, maxWidth: 80,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_remarks'), field: 'remarks', sorter: 'string', resizable: false,
                    responsive: 1, widthGrow: 1,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    formatter: () => {
                        return "<i class='bi bi-pencil-fill'></i>"
                    },
                    headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", resizable: false,
                    headerSort: false, width: 10, responsive: 0,
                    cellClick: (e, row, formatterParams) => {
                        this.updateMode = true
                        this.updateItemID = row.getData().id
                        this.$refs.filterDetailContentBox.updateModeChange(row.getData().outCode)
                        this.$refs.locationSearchBox.updateMode(row.getData().lid)
                        this.$refs.qtyProcessor.updateModeOnQty({
                            "qty": row.getData().qty,
                            "ctn": row.getData().ctn
                        })
                        this.getQty = row.getData().qty
                        this.getCtn = row.getData().ctn
                        this.getLot = row.getData().lot
                        this.getCost = row.getData().cost
                        this.getRemarks = row.getData().remarks
                        this.getOrigin = row.getData().origin
                        this.expiryDate = row.getData().expiryDate
                        this.receiveDate = row.getData().receiveDate
                    }
                },
                {
                    formatter: () => {
                        return "<i class='bi bi-trash-fill'></i>"
                    },
                    headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", resizable: false,
                    headerSort: false, width: 10, responsive: 0,
                    cellClick: (e, row, formatterParams) => {
                        this.$swal.fire({
                            title: this.$t('common_confirm_action_delete'),
                            icon: 'info'
                        }).then(result => {
                            if(result.isConfirmed){
                                let data = this.tabulator.getData()
                                data = data.filter(a => a.id !== row.getData().id)
                                this.tabulator.setData(data)
                            }
                        })
                    }
                },
            ],
            reactiveData: true, //enable data reactivity
            maxHeight: '90vh',
            responsiveLayout: 'collapse',
            layout: "fitColumns",
            movableColumns: true,
            movableRows: false,
            initialSort: [
                {column: "id", dir: "desc"},
            ],
            rowFormatter: (row, e) => {
                if(row.getData().is_error === true){
                    row.getElement().style.backgroundColor = "#fac3c3"
                }
            }
        })
    }
}
</script>

<style scoped>

</style>
